module.exports = __webpack_public_path__ + "static/content-wordpress-6c454e7e8d8364055a4e778b1309f93d.jpg";